module.exports = __webpack_public_path__ + "fonts/GT-Cinetype-Mono.172a88d4.woff2";